export const SetPasswordRouting = {
  path: "/setPassword",
  name: "setPassword",
  meta: { title: "设置密码" },
  component: () => import(/* webpackChunkName: "join" */ "@/views/join/h5/set-password/index.vue"),
  children: [],
};
